import React from 'react';
import { Link } from 'lib/tanstack-router/routerAdapter';
// MATERIAL-UI
import Typography from '@mui/material/Typography';
// COMPONENTS
import EmptyState from '../common/EmptyState';

const NotFound = () => {
  const pageText = (
    <div>
      <Typography variant="body1">That page does not exist.</Typography>
      <Link to="/">Home</Link>
    </div>
  );

  return (
    <div data-testid="not-found-page">
      <EmptyState pageTitle="Not Found" pageText={pageText} />
    </div>
  );
};

export default NotFound;
